export const ISSUE_FIELDS_FEEDBACK_URL = 'https://github.com/orgs/community/discussions/175366'
export const ISSUE_FIELDS_STAFF_FEEDBACK_URL = 'https://github-grid.enterprise.slack.com/archives/C0969KWTU01'
